export const ROUTER_ERROR_PAGE_NAME = 'error:server';
